<template>
    <v-navigation-drawer
        
        app
        temporary
        v-model="display"
        class="site-menu"
    >
        <v-list nav>
            <template v-for="(item, i) in availableNavItems">
                <v-list-group
                    v-if="item.children"
                    :key="i"
                    :prepend-icon="item.icon"
                >
                    <template v-slot:activator>
                        <v-list-item-title>{{item.text}}</v-list-item-title>
                    </template>

                    <template v-for="(child, j) in item.children">
                        <nav-item
                            v-if="child.route"
                            :key="j"
                            :item="child"
                        >
                        </nav-item>
                    </template>
                </v-list-group>

                <nav-item
                    v-if="item.route"
                    :key="i"
                    :item="item"
                >
                </nav-item>
            </template>
        </v-list>
    </v-navigation-drawer>
</template>

<style>
    /* don't use the standard <a> styling for the menu (blue and underlined) */
    #app .site-menu a {
        text-decoration: none;
        color: inherit;
    }
</style>

<script>

import navItem from "./NavItem.vue";
import * as auth from '@/services/auth';

export default {
    components: {
        navItem: navItem
    },
    data() {
        return {
            navItems: [
                {
                    icon: "home",
                    text: "Home",
                    route: "home"
                },
                {
                    icon: "gesture",
                    text: "Specimens",
                    route: "specimens"
                },
                {
                    icon: "folder_shared",
                    text: "Venom Profile",
                    route: "venomprofile"
                },
                {
                    icon: "check_box",
                    text: "Husbandry",
                    route: "husbandry"
                },
                {
                    icon: "assignment",
                    text: "Husbandry Reporting",
                    route: "husbandryreporting"
                },
                {
                    icon: "group_work",
                    text: "Husbandry Room Activity Report",
                    route: "husbandryroomreport"
                },
                {
                    icon: "folder_open",
                    text: "Medical Records",
                    route: "medicalRecords"
                },
                {
                    icon: "apps",
                    text: "Venom Pooling",
                    children: [
                        {
                            icon: "today",
                            text: "Daily Extraction",
                            route: "dailyextractions"
                        },
                        {
                            icon: "pool",
                            text: "Monthly Pool",
                            route: "monthlypools"
                        },
                        {
                            icon: "mdi-blur-linear",
                            text: "Species Batch Pools",
                            route: "speciesBatchPools"
                        },
                        {
                            icon: "date_range",
                            text: "Venom Lots",
                            route: "venomlots"
                        },
                    ]
                },
                {
                    icon: "list",
                    text: "Data Management",
                    children: [
                        {
                            icon: "view_module",
                            text: "Species",
                            route: "species"
                        },
                        {
                            icon: "place",
                            text: "Locations",
                            route: "locations"
                        },
                        {
                            icon: "input",
                            text: "Suppliers",
                            route: "suppliers"
                        },
                        {
                            icon: "mdi-flask",
                            text: "Venom Types",
                            route: "venomtypes"
                        },
                    ]
                },
                {
                    icon: "security",
                    text: "Administration",
                    children: [
                        {
                            icon: "group",
                            text: "Users",
                            route: "users"
                        },
                        {
                            icon: "notifications",
                            text: "Alerts",
                            route: "alerts"
                        },
                        {
                            icon: "list",
                            text: "Auditing",
                            route: "auditing"
                        },
                    ]
                },
                {
                    icon: "keyboard_return",
                    text: "Logout",
                    route: "logout"
                },
            ]
        };
    },
    computed: {
        display: {
            get() {
                return this.$store.state.generalStore.displayNavDrawer;
            },
            set(value) {
                this.$store.commit("generalStore/setDisplayNavDrawer", value);
            }
        },
        availableNavItems() {
            let routes = this.$router.options.routes;
            let includeRoute = function(routeToCheck){
                for(let i = 0; i < routes.length; i++){
                    let route = routes[i];
                    
                    if(route.name === routeToCheck){
                        return !route.meta || !route.meta.requiredPermissions || auth.hasPermissions(route.meta.requiredPermissions)
                    }
                }

                return false;
            }

            let shallowCopy = function(obj){
                let newObj = {};
                for(let property in obj){
                    if({ }.hasOwnProperty.call(obj, property)){
                        newObj[property] = obj[property];
                    }
                }
                return newObj;
            }

            let availableNavItems = [];
            let navItems = this.navItems;

            navItems.forEach(navItem => {
                if(navItem.route) {
                    if(includeRoute(navItem.route)) {
                        availableNavItems.push(navItem);
                    }
                }
                else if(navItem.children) {
                    var newNavItem = shallowCopy(navItem);
                    newNavItem.children = [];

                    navItem.children.forEach(child => {
                        if(includeRoute(child.route)){
                            newNavItem.children.push(child);
                        }
                    });

                    if(newNavItem.children.length > 0){
                        availableNavItems.push(newNavItem);
                    }
                }
            });

            return availableNavItems;
        }
    },
    methods: {
        
    }
}

</script>